import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import { withRouter } from 'react-router-dom';
import CommToolContext from '../../common/comm_tool_context';
import { getIPSProject, getIpsTeamRoleMembers } from '../../../api';
import ProjectTabRoutes from '../../../components/ProjectTabsList/ProjectTabRoutes';
import AssetInstall from '../Asset/IpsAssetInstall';
import IPSAsset from '../Asset/IpsAssetRemoval';
import IPSProjectTeam from '../ipsproject_team';
import NewDataTrackerTabContainer from './newDataTrackerTabContainer';

const { TabPane } = Tabs;
function NewDataTrackersTabs(props) {
    const { context, history, status, match } = props;

    return (
        <CommToolContext.Consumer>
            {context => (
                <div className="container-fluid">
                    <ProjectTabRoutes context={context} history={history} status={"datatracker_progress"} />
                    <Tabs
                        defaultActiveKey='details'
                        className='nav-B'
                        type='card'
                        activeKey={match.params.tabId || 'details'}
                    >
                        <TabPane tab="Data Tracker" key="details">
                            <NewDataTrackerTabContainer
                                context={context}
                                history={history}
                                status={status}
                            />
                        </TabPane>
                    </Tabs>
                </div>
            )}
        </CommToolContext.Consumer>
    );

}

//NewDataTrackersTabs.contextType = NewDataTrackersTabs;
export default withRouter(NewDataTrackersTabs);